import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-pre-render-calendar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pre-render-calendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderCalendarComponent {
  // routerValidatorService = inject(RouteValidatorService);
  isfloating = input(false);

  urlIcon = environment.urlIcon;
  selectedDay: number | null = null;
  selectedMonth: number | null = null;
  selectedYear: number | null = null;

  days: number[] = [];
  weeks: number[][] = [
    [1, 2, 3, 4, 5, 6, 7],
    [8, 9, 10, 11, 12, 13, 14],
    [15, 16, 17, 18, 19, 20, 21],
    [22, 23, 24, 25, 26, 27, 28],
    [29, 30, 31, 0, 0, 0, 0],
  ];
  // today: Date = new Date();

  // abbreviationsMonth = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  abbreviationsMonth = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
  monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  // monthNames = [
  //   'January',
  //   'February',
  //   'March',
  //   'April',
  //   'May',
  //   'June',
  //   'July',
  //   'August',
  //   'September',
  //   'October',
  //   'November',
  //   'December',
  // ];
}
